module.exports = __webpack_public_path__ + "static/media/comment.d525b846.svg";